import { socialMediaPagesLink } from "@/utils/constants/supportInfo";
import {
  FacebookWithColorIcon,
  InstagramIcon,
  TiktokIcon,
  YoutubeWithColorIcon,
} from "@/components/data-display/Icon";

function MediaLink() {
  return (
    <div className="mt-[0.7rem] px-2">
      <div className="mt-[1rem] flex items-center gap-[1.875rem] sm:mt-0">
        <a
          href={socialMediaPagesLink.facebook}
          target="_blank"
          rel="noreferrer"
        >
          <FacebookWithColorIcon className="h-[1.5rem] w-[1.5rem] sm:h-[1.75rem] sm:w-[1.50rem]" />
        </a>
        <a
          href={socialMediaPagesLink.instagram}
          target="_blank"
          rel="noreferrer"
        >
          <InstagramIcon />
        </a>

        <a href={socialMediaPagesLink.youtube} target="_blank" rel="noreferrer">
          <YoutubeWithColorIcon className="h-[0.938rem] w-[1.375rem] sm:h-[1.125rem] sm:w-[1.625rem]" />
        </a>

        <a href={socialMediaPagesLink.tiktok} target="_blank" rel="noreferrer">
          <TiktokIcon />
        </a>
      </div>
    </div>
  );
}
export default MediaLink;
